import { directPowerDisplayAs } from "@arenko-group/arenko-ui/dist/enums";
import { stringToLocalFormattedDateString } from "@arenko-group/arenko-ui/dist/helpers";
import { capitalize } from "lodash";
import type {
  DirectPowerDisplayAsKey,
  Profile,
  Schedule,
  TableProfile,
  TimeRange,
} from "@/types/data/schedule.types";
import TableProfileRowModel from "./AgGridProfileRow.model";

export type DataObject = {
  id: string;
  service: string;
  output: string;
  state: string;
  origin: string;
  created: string;
  locked: boolean;
  profiles: Profile[];
  absolutes: Profile[];
  bases: Profile[];
  timeRange: TimeRange<number>;
  correspondingSchedule: Schedule;
};
// TODO - this looks very much BE work i think i could be oprimised and removed
export default class TableRowModel {
  id?: string;
  type?: string;
  origin?: string;
  created?: string;
  state?: string;
  updatedAt?: string;
  profiles?: TableProfile[];

  constructor(data: DataObject) {
    if (!data) {
      return;
    }

    this.id = data?.id || "";
    this.type =
      directPowerDisplayAs[data?.service as DirectPowerDisplayAsKey] ||
      capitalize(data?.service);

    this.origin = data?.origin || "";
    this.created = data?.created
      ? stringToLocalFormattedDateString({
          date: data.created,
          withSeconds: true,
        })
      : "";
    this.state = data?.state || "";

    const { correspondingSchedule } = data;
    this.profiles = [];

    if (correspondingSchedule?.profile) {
      this.profiles = correspondingSchedule.profile.map(
        (p) => new TableProfileRowModel(p)
      );
    }

    this.updatedAt = "";
    if (correspondingSchedule?.state?.updatedAt) {
      this.updatedAt = stringToLocalFormattedDateString({
        date: correspondingSchedule.state.updatedAt,
        withSeconds: true,
      });
    }
  }
}
